import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import AbortablePromise from '../abortablePromise/AbortablePromise.js';

var AbortablePoller = /** @class */ (function () {
    function AbortablePoller(asyncFn, interval, timeout, inspect) {
        this.asyncFn = asyncFn;
        this.interval = interval;
        this.timeout = timeout;
        this.controller = new AbortController();
        this.currentPollState = 'NOT_STARTED';
        this.inspect = inspect;
    }
    AbortablePoller.create = function (asyncFn, interval, timeout, inspect) {
        if (interval === void 0) { interval = 3000; }
        if (timeout === void 0) { timeout = 180000; }
        if (inspect === void 0) { inspect = function () { }; }
        return new AbortablePoller(asyncFn, interval, timeout, inspect);
    };
    AbortablePoller.prototype.setPollParameters = function (parameters) {
        this.pollParameters = parameters;
        return this;
    };
    AbortablePoller.prototype.getPollParameters = function () {
        return this.pollParameters;
    };
    AbortablePoller.prototype.onStateChange = function (callback) {
        this.stateCallback = callback;
        return this;
    };
    AbortablePoller.prototype.currentState = function () {
        return this.currentPollState;
    };
    AbortablePoller.prototype.updatePollState = function (newState) {
        this.currentPollState = newState;
        if (this.stateCallback) {
            this.stateCallback(newState);
        }
    };
    AbortablePoller.prototype.start = function () {
        var _this = this;
        if (this.currentState() === 'STARTED' && this.abortablePromise) {
            return this.abortablePromise;
        }
        if (['ABORTED', 'TIMEOUT', 'COMPLETED'].includes(this.currentPollState)) {
            this.controller = new AbortController();
        }
        var signal = this.controller.signal;
        this.abortablePromise = new AbortablePromise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var timerId, timeoutId, poll, clearTimeouts;
            var _this = this;
            return __generator(this, function (_a) {
                timerId = null;
                timeoutId = null;
                poll = function () { return __awaiter(_this, void 0, void 0, function () {
                    var result, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (signal.aborted) {
                                    clearTimeouts();
                                    this.updatePollState('ABORTED');
                                    return [2 /*return*/, reject(new Error('Poller aborted'))];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.asyncFn(this.pollParameters)];
                            case 2:
                                result = _a.sent();
                                this.inspect(result.result);
                                if (result.isCompleted) {
                                    this.updatePollState('COMPLETED');
                                    clearTimeouts();
                                    return [2 /*return*/, resolve(result.result)];
                                }
                                if (!signal.aborted) {
                                    timerId = setTimeout(poll, this.interval);
                                }
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _a.sent();
                                if (error_1 instanceof Error && AbortablePoller.checkForNetworkError(error_1)) {
                                    timerId = setTimeout(poll, this.interval);
                                }
                                else {
                                    clearTimeouts();
                                    reject(error_1);
                                }
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/, null];
                        }
                    });
                }); };
                clearTimeouts = function () {
                    if (timerId)
                        clearTimeout(timerId);
                    if (timeoutId)
                        clearTimeout(timeoutId);
                };
                timeoutId = setTimeout(function () {
                    _this.updatePollState('TIMEOUT');
                    clearTimeouts();
                    reject(new Error('Polling timed out'));
                }, this.timeout);
                this.updatePollState('STARTED');
                poll();
                return [2 /*return*/];
            });
        }); });
        return this.abortablePromise;
    };
    AbortablePoller.prototype.abort = function () {
        this.controller.abort();
    };
    AbortablePoller.networkMessages = ['Network request failed', 'Failed to fetch', 'NETWORK_ERROR', 'NETWORK', 'fetch'];
    AbortablePoller.checkForNetworkError = function (error) {
        var reg = new RegExp(AbortablePoller.networkMessages.join('|'), 'i');
        return reg.test(error.message);
    };
    return AbortablePoller;
}());

export { AbortablePoller as default };
